import { Stack, Text } from "@chakra-ui/react";
import type { PropsWithChildren } from "react";
import { BaseStatCard } from "../card";

export interface NoResultCardProps extends PropsWithChildren {
  name: string;
  description: string;
}
export const NoResultCard = ({
  name,
  description,
  children,
}: NoResultCardProps) => (
  <BaseStatCard bg="white">
    <Stack spacing={{ base: "4", md: "5" }}>
      <Stack spacing={{ base: "1", md: "2" }}>
        <Text fontSize={{ base: "lg", md: "xl" }} fontWeight="medium">
          {name}
        </Text>
        <Text color="muted">{description}</Text>
      </Stack>
      {children}
    </Stack>
  </BaseStatCard>
);
